module.exports = __webpack_public_path__ + "static/media/aboriginalflag.328be05c.svg";